<script lang="ts">
 import type {Employee} from "$lib/types/employee";
 import VerticalGrid from "$lib/components/VerticalGrid.svelte";
 import InfoBox from "$items/InfoBox.svelte";
 import type {Writable} from "svelte/store";
 import {getContext, onMount} from "svelte";
 import {getLanguages} from "$lib/calls/i18n";
 import Typeahead from "$lib/components/Typeahead.svelte";
 import {Button} from "flowbite-svelte";
 import {MinusOutline} from "flowbite-svelte-icons";
 import {post, retire} from "$lib/api";
 import {referenceLanguages} from "$lib/stores/references";

 export let employee: Employee;

 let super_edit: Writable<boolean> = getContext('super_edit');
 let newLanguage: string = '';
 let languages: {value: string, name: string}[] = [];

 let addLanguage = async (lang:{value: string, name: string}) => {
     if (!newLanguage) return;
     if(typeof employee.languages === 'undefined') employee.languages = []
     const languageObject = {employeeId: employee.id, languageIsoCode: lang.value};
     newLanguage = ''
     employee.languages = [...(await post('/employee/' + employee.uuid + '/language', languageObject)).languages]

 }

 const deleteLanguage = async (id: number) => {
     employee.languages = [...(await retire('/employee/' + employee.uuid + '/language/' + id)).languages]
 }

 onMount(async () => {
     if($referenceLanguages.length === 0){
         $referenceLanguages = await getLanguages();
     }
     const i18nLanguages = $referenceLanguages;
     Object.keys(i18nLanguages).forEach((key:string) => {
         languages.push({value: key, name: i18nLanguages[key].name + ' (' + key + ') ' + i18nLanguages[key].nativeName})
     })
     languages = languages
 })
</script>

<VerticalGrid>
    <div class="font-medium block dark:text-gray-300 text-lg leading-6 text-gray-500" >Sprachen</div>
    {#if languages.length > 0}
        {#each employee.languages || [] as language}
            <div class="flex gap-1">
                <div class="flex-1">
                    <InfoBox value={languages.find(x => x.value === language.languageIsoCode)?.name} readonly/>
                </div>
                {#if $super_edit}
                    <Button color="red" pill class="!p-2" on:click={() => deleteLanguage(language.id)}>
                        <MinusOutline class="w-4 h-4"/>
                    </Button>
                {/if}
            </div>

        {/each}
    {/if}
    <svelte:fragment slot="right">
        {#if $super_edit}
            <Typeahead placeholder="Neue Sprache" bind:value={newLanguage} extract={addLanguage} data={languages}/>
        {/if}
    </svelte:fragment>
</VerticalGrid>